export enum AppBackendRequestTypes {
  GetDashboardDetailViewRequest = 'appbackend/GET_DASHBOARD_DETAIL_VIEW_REQUEST',
  GetDashboardDetailViewSuccess = 'appbackend/GET_DASHBOARD_DETAIL_VIEW_SUCCESS',
  GetDashboardDetailViewFailure = 'appbackend/GET_DASHBOARD_DETAIL_VIEW_FAILURE',
  GetFunnelDetailViewRequest = 'appbackend/GET_FUNNEL_DETAIL_VIEW_REQUEST',
  GetFunnelDetailViewSuccess = 'appbackend/GET_FUNNEL_DETAIL_VIEW_SUCCESS',
  GetFunnelDetailViewFailure = 'appbackend/GET_FUNNEL_DETAIL_VIEW_FAILURE',
  GetHeatmapDetailViewRequest = 'appbackend/GET_HEATMAP_DETAIL_VIEW_REQUEST',
  GetHeatmapDetailViewSuccess = 'appbackend/GET_HEATMAP_DETAIL_VIEW_SUCCESS',
  GetHeatmapDetailViewFailure = 'appbackend/GET_HEATMAP_DETAIL_VIEW_FAILURE',
  GetHomeViewRequest = 'appbackend/GET_HOME_VIEW_REQUEST',
  GetHomeViewSuccess = 'appbackend/GET_HOME_VIEW_SUCCESS',
  GetHomeViewFailure = 'appbackend/GET_HOME_VIEW_FAILURE',
  GetJourneyDetailViewRequest = 'appbackend/GET_JOURNEY_DETAIL_VIEW_REQUEST',
  GetJourneyDetailViewSuccess = 'appbackend/GET_JOURNEY_DETAIL_VIEW_SUCCESS',
  GetJourneyDetailViewFailure = 'appbackend/GET_JOURNEY_DETAIL_VIEW_FAILURE',
  GetMetricDetailViewRequest = 'appbackend/GET_METRIC_DETAIL_VIEW_REQUEST',
  GetMetricDetailViewSuccess = 'appbackend/GET_METRIC_DETAIL_VIEW_SUCCESS',
  GetMetricDetailViewFailure = 'appbackend/GET_METRIC_DETAIL_VIEW_FAILURE',
  GetSegmentDetailViewRequest = 'appbackend/GET_SEGMENT_DETAIL_VIEW_REQUEST',
  GetSegmentDetailViewSuccess = 'appbackend/GET_SEGMENT_DETAIL_VIEW_SUCCESS',
  GetSegmentDetailViewFailure = 'appbackend/GET_SEGMENT_DETAIL_VIEW_FAILURE',
  GetRetentionMetricDetailViewRequest = 'appbackend/GET_RETENTION_METRIC_DETAIL_VIEW_REQUEST',
  GetRetentionMetricDetailViewSuccess = 'appbackend/GET_RETENTION_METRIC_DETAIL_VIEW_SUCCESS',
  GetRetentionMetricDetailViewFailure = 'appbackend/GET_RETENTION_METRIC_DETAIL_VIEW_FAILURE',
  GetSidebarRequest = 'appbackend/GET_SIDEBAR_REQUEST',
  GetSidebarSuccess = 'appbackend/GET_SIDEBAR_SUCCESS',
  GetSidebarFailure = 'appbackend/GET_SIDEBAR_FAILURE',
  GetNamedElementDetailViewRequest = 'appbackend/GET_NAMED_ELEMENT_DETAIL_VIEW_REQUEST',
  GetNamedElementDetailViewSuccess = 'appbackend/GET_NAMED_ELEMENT_DETAIL_VIEW_SUCCESS',
  GetNamedElementDetailViewFailure = 'appbackend/GET_NAMED_ELEMENT_DETAIL_VIEW_FAILURE',
  GetNamedElementSettingsRequest = 'appbackend/GET_NAMED_ELEMENT_SETTINGS_REQUEST',
  GetNamedElementSettingsSuccess = 'appbackend/GET_NAMED_ELEMENT_SETTINGS_SUCCESS',
  GetNamedElementSettingsFailure = 'appbackend/GET_NAMED_ELEMENT_SETTINGS_FAILURE',
  BulkArchiveNamedElementsRequest = 'appbackend/BULK_ARCHIVE_NAMED_ELEMENTS_REQUEST',
  BulkArchiveNamedElementsSuccess = 'appbackend/BULK_ARCHIVE_NAMED_ELEMENTS_SUCCESS',
  BulkArchiveNamedElementsFailure = 'appbackend/BULK_ARCHIVE_NAMED_ELEMENTS_FAILURE',
  GetVirtualDashboardRequest = 'appbackend/GET_VIRTUAL_DASHBOARD_REQUEST',
  GetVirtualDashboardSuccess = 'appbackend/GET_VIRTUAL_DASHBOARD_SUCCESS',
  GetVirtualDashboardFailure = 'appbackend/GET_VIRTUAL_DASHBOARD_FAILURE',
  ObjectViewedRequest = 'appbackend/OBJECT_VIEWED_REQUEST',
  ObjectViewedSuccess = 'appbackend/OBJECT_VIEWED_SUCCESS',
  ObjectViewedFailure = 'appbackend/OBJECT_VIEWED_FAILURE',
  GetDefinedEventDetailViewRequest = 'appbackend/GET_DEFINED_EVENT_DETAIL_VIEW_REQUEST',
  GetDefinedEventDetailViewSuccess = 'appbackend/GET_DEFINED_EVENT_DETAIL_VIEW_SUCCESS',
  GetDefinedEventDetailViewFailure = 'appbackend/GET_DEFINED_EVENT_DETAIL_VIEW_FAILURE',
  GetDefinedEventSettingsRequest = 'appbackend/GET_DEFINED_EVENT_SETTINGS_REQUEST',
  GetDefinedEventSettingsSuccess = 'appbackend/GET_DEFINED_EVENT_SETTINGS_SUCCESS',
  GetDefinedEventSettingsFailure = 'appbackend/GET_DEFINED_EVENT_SETTINGS_FAILURE',
  BulkArchiveDefinedEventsRequest = 'appbackend/BULK_ARCHIVE_DEFINED_EVENTS_REQUEST',
  BulkArchiveDefinedEventsSuccess = 'appbackend/BULK_ARCHIVE_DEFINED_EVENTS_SUCCESS',
  BulkArchiveDefinedEventsFailure = 'appbackend/BULK_ARCHIVE_DEFINED_EVENTS_FAILURE',
  GetAPIEventDetailViewRequest = 'appbackend/GET_API_EVENT_DETAIL_VIEW_REQUEST',
  GetAPIEventDetailViewSuccess = 'appbackend/GET_API_EVENT_DETAIL_VIEW_SUCCESS',
  GetAPIEventDetailViewFailure = 'appbackend/GET_API_EVENT_DETAIL_VIEW_FAILURE',
  SnoozeAPIEventIssueRequest = 'appbackend/SNOOZE_API_EVENT_ISSUE_REQUEST',
  SnoozeAPIEventIssueSuccess = 'appbackend/SNOOZE_API_EVENT_ISSUE_SUCCESS',
  SnoozeAPIEventIssueFailure = 'appbackend/SNOOZE_API_EVENT_ISSUE_FAILURE',
  UnSnoozeAPIEventIssueRequest = 'appbackend/UNSNOOZE_API_EVENT_ISSUE_REQUEST',
  UnSnoozeAPIEventIssueSuccess = 'appbackend/UNSNOOZE_API_EVENT_ISSUE_SUCCESS',
  UnSnoozeAPIEventIssueFailure = 'appbackend/UNSNOOZE_API_EVENT_ISSUE_FAILURE',
  GetPageSettingsRequest = 'appbackend/GET_PAGE_SETTINGS_REQUEST',
  GetPageSettingsSuccess = 'appbackend/GET_PAGE_SETTINGS_SUCCESS',
  GetPageSettingsFailure = 'appbackend/GET_PAGE_SETTINGS_FAILURE',
  GetPageDetailViewRequest = 'appbackend/GET_PAGE_DETAIL_VIEW_REQUEST',
  GetPageDetailViewSuccess = 'appbackend/GET_PAGE_DETAIL_VIEW_SUCCESS',
  GetPageDetailViewFailure = 'appbackend/GET_PAGE_DETAIL_VIEW_FAILURE',
  BulkArchivePagesRequest = 'appbackend/BULK_ARCHIVE_PAGES_REQUEST',
  BulkArchivePagesSuccess = 'appbackend/BULK_ARCHIVE_PAGES_SUCCESS',
  BulkArchivePagesFailure = 'appbackend/BULK_ARCHIVE_PAGES_FAILURE',
  GetPropertyDetailViewRequest = 'appbackend/GET_PROPERTY_DETAIL_VIEW_REQUEST',
  GetPropertyDetailViewSuccess = 'appbackend/GET_PROPERTY_DETAIL_VIEW_SUCCESS',
  GetPropertyDetailViewFailure = 'appbackend/GET_PROPERTY_DETAIL_VIEW_FAILURE',
  GetPropertySettingsRequest = 'appbackend/GET_PROPERTY_SETTINGS_REQUEST',
  GetPropertySettingsSuccess = 'appbackend/GET_PROPERTY_SETTINGS_SUCCESS',
  GetPropertySettingsFailure = 'appbackend/GET_PROPERTY_SETTINGS_FAILURE',
  BulkArchivePropertiesRequest = 'appbackend/BULK_ARCHIVE_PROPERTIES_REQUEST',
  BulkArchivePropertiesSuccess = 'appbackend/BULK_ARCHIVE_PROPERTIES_SUCCESS',
  BulkArchivePropertiesFailure = 'appbackend/BULK_ARCHIVE_PROPERTIES_FAILURE',
}
